<template>
  <v-container>
      <v-card>
        <v-toolbar dark dense color="black"><h1> Catálogo de análisis de riesgo</h1>
          <v-spacer></v-spacer>
           <!-- EXCEL -->
            <v-btn small align="right" class="ma-2" color="green" dark>
              <download-excel
                :data="docum"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="AnalisisRiesgos.xls"
              >
                Excel
                <v-icon class="ma-1">mdi-download</v-icon>
              </download-excel>
            </v-btn>
        </v-toolbar>
      </v-card>

      <v-row>
        <v-col>
          <v-card elevation='10'>
            <v-card-title>

          <v-spacer></v-spacer>
            <v-col cols="3">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
               >
                  <template v-slot:activator="{ on, attrs }">
                     <v-text-field
                        class="mx-2"
                        v-model="fecha1"
                        label="Fecha Inicial"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                     ></v-text-field>
                  </template>
                    <v-date-picker
                      v-model="fecha1"
                      @input="menu1 = false"
                    ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="3">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
               >
                  <template v-slot:activator="{ on, attrs }">
                     <v-text-field
                        class="ma-2"
                        v-model="fecha2"
                        label="Fecha Final"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                     ></v-text-field>
                  </template>
                    <v-date-picker
                      v-model="fecha2"
                      @input="menu2 = false"
                    ></v-date-picker>
              </v-menu>
            </v-col>

              <v-btn
                small
                @click ="consultar"
                color="info"
                >Consultar
              </v-btn>

            <v-spacer></v-spacer>

            <v-col cols="2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Filtrar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>


            <v-col cols="2">
              <v-btn align="right"
                color="orange" dark small
                class="ma-2"
                :to="{ name: 'ar' }" >Nuevo
             </v-btn>
            </v-col>

              </v-card-title>

            <v-row>
              <v-col>
              <v-data-table
                heigth="400"
                :headers="headers"
                :items="docum"
                :search="search"
                dense
              >
              <template v-slot:item="{ item }" >
                <tr v-on:dblclick="editar(item)">
                  <td>{{ item.iddocum}}</td>
                  <td>{{ item.nomina }}</td>
                  <td>{{ item.nomuser }}</td>
                  <td>{{ item.nomplanta }}</td>
                  <td>{{ item.nomarea }}</td>
                  <td>{{ item.tarea }}</td>
                  <td>{{ item.fecha }}</td>
                  <td>{{ item.hora }}</td>
                </tr>
              </template>
              </v-data-table>
              </v-col>
            </v-row>

          </v-card>

        </v-col>
      </v-row>

  </v-container>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      docum: [],

      fecha1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fecha2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      menu1: false,
      menu2: false,

      headers: [
        { text: 'Id A.R.', value: 'iddocum'},
        { text: 'Id Usuario', value: 'nomina' },
        { text: 'Nombre de usuario', value: 'nomuser' },
        { text: 'Planta', value: 'nomplanta' },
        { text: 'Area', value: 'nomarea' },
        { text: 'Tarea', value: 'tarea' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Hora', value: 'hora' },
      ],
      json_fields: {
        Id: "iddocum",
        Nomina: "nomina",
        Nombre: "nomuser",
        Planta: "nomplanta",
        Area:   "nomarea",
        Tarea:  "tarea",
        Fecha:  "fecha",
        Hora:   "hora",

      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      json_data: [],
    }
      
  },
  created(){
    this.consultar()
    // Definir valores iniciales
    // Fecha inicial Primero de mes.
    let date0 = new Date()
    let mes = date0.getMonth()
    let anio = date0.getFullYear()
            
    // console.log(mes, anio)
    this.fecha1 = new Date(anio, mes, 1).toISOString().substr(0, 10)
    this.consultar()
  },

  methods: {
      
    consultarlist(){
      // limpiar
      this.docum= []
      this.$http.get("v2/ar.list" ).then(response=>{
        if (response.data.error===null){
          this.docum = response.data.result

          // this.docum.forEach( element => {
          //   element.fechastart = element.fechastart.substr(0,10)
          //   element.hora = element.fechastart.substr(11,17)
          // })

          console.log("docum", this.docum)
        }
          
      }).catch(error=>{
        console.log(error)
      })


    },
      
      
    consultar() {

      let payload = {
        fecha1: this.fecha1,
        fecha2: this.fecha2
      }

      // limpiar
      this.docum= []
      this.$http.post("v2/ar.confechas", payload ).then(response=>{
        if (response.data.error===null){
          this.docum = response.data.result

          // this.docum.forEach( element => {
          //   element.fechastart = element.fechastart.substr(0,10)
          //   element.hora = element.fechastart.substr(11,17)
          // })

          console.log("docum", this.docum)
        }
          
      }).catch(error=>{
        console.log(error)
      })


    },
      
      



    editar(item){
      console.log("Renglonitem", item)
      this.$router.push({name:'ar', params: {docum:item}})
    },

  }
}

</script>